import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { UploadDialog } from '../upload-dailog.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-osh',
  templateUrl: './osh.component.html',
  styleUrls: ['./osh.component.css'],
})
export class OshComponent {
  buttonClicked = false;
  success = false;
  status;

  osh = {
    client: null as any,
    oshFrameworkExcelFile: null as any,
    firstSixDaysExcelFile: null as any,
    postSixDaysExcelFile: null as any,
    zipFile: null as any,
  };

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  clients = JSON.parse(sessionStorage.getItem('clients'));
  resp = [] as any;

  ngOnInit(): void {
    this.mixpanel.track('page_view', {
      page: 'OSH',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
  }

  upload(status: boolean) {
    this.status = status;
    const formData = new FormData();
    formData.append('oshFrameworkExcelFile', this.osh.oshFrameworkExcelFile);
    formData.append('firstSixDaysExcelFile', this.osh.firstSixDaysExcelFile);
    formData.append('postSixDaysExcelFile', this.osh.postSixDaysExcelFile);
    formData.append('zipFile', this.osh.zipFile);
    formData.append('client', this.osh.client);
    if (status) {
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buttonClicked = true;
          this.mixpanel.track('button_click', {
            page: 'OSH',
            category: 'Dashboard',
            button: 'Upload',
          });
          formData.append('commit', 'yes');
          this.apiCall(formData);
        } else {
          //pass
        }
      });
    } else {
      this.buttonClicked = true;
      this.mixpanel.track('button_click', {
        page: 'OSH',
        category: 'Dashboard',
        button: 'Verify',
      });
      this.apiCall(formData);
    }
  }

  apiCall(formData) {
    this.api.osh(formData).subscribe(
      (data: any) => {
        this.buttonClicked = false;
        this.success = true;
        if (data.data.length > 0) {
          this.resp = this.sanitizer.bypassSecurityTrustHtml(
            data.data.join('')
          );
        } else {
          this.resp = null;
        }
        this.response(false);
        if (data.status) {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'success',
          });
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }

  remove_xl1() {
    this.osh.oshFrameworkExcelFile = null;
  }

  onFileSelected1(event: any): void {
    this.osh.oshFrameworkExcelFile = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
    };
    fileReader.readAsArrayBuffer(this.osh.oshFrameworkExcelFile);
  }

  remove_xl2() {
    this.osh.firstSixDaysExcelFile = null;
  }

  onFileSelected2(event: any): void {
    this.osh.firstSixDaysExcelFile = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
    };
    fileReader.readAsArrayBuffer(this.osh.firstSixDaysExcelFile);
  }

  remove_xl3() {
    this.osh.postSixDaysExcelFile = null;
  }

  onFileSelected3(event: any): void {
    this.osh.postSixDaysExcelFile = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
    };
    fileReader.readAsArrayBuffer(this.osh.postSixDaysExcelFile);
  }

  remove_xl4() {
    this.osh.zipFile = null;
  }

  onFileSelected4(event: any): void {
    this.osh.zipFile = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
    };
    fileReader.readAsArrayBuffer(this.osh.zipFile);
  }

  response(status) {
    if (status) {
      this.mixpanel.track('button_click', {
        page: 'OSH',
        category: 'Dashboard',
        button: 'View Log',
      });
    }
    if (this.resp != null) {
      this._bottomSheet.open(OshResponse, { data: this.resp });
    }
  }
}

@Component({
  selector: 'osh-response',
  templateUrl: './osh-response.html',
})
export class OshResponse {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<OshComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: []
  ) {}
}
